export enum AmbientMode {
    NONE = 0,
    AURA = 1,
    NOTES = 2,
    HEARTS = 3,
    SPARKLE = 4,
    ALERT = 5,
    MIC = 6,
}

export const AMBIENT_MODE_NAMES: Record<AmbientMode, string> = {
    [AmbientMode.NONE]: 'NONE',
    [AmbientMode.AURA]: 'AURA',
    [AmbientMode.NOTES]: 'NOTES',
    [AmbientMode.HEARTS]: 'HEARTS',
    [AmbientMode.SPARKLE]: 'SPARKLE',
    [AmbientMode.ALERT]: 'ALERT',
    [AmbientMode.MIC]: 'MIC',
};

export const ALL_AMBIENT_MODES = Object.values(AmbientMode)
    .filter((v): v is AmbientMode => typeof v === 'number');

export function ambientUsesAura(mode: AmbientMode): boolean {
    return mode === AmbientMode.AURA;
}

export function ambientUsesParticles(mode: AmbientMode): boolean {
    return mode === AmbientMode.NOTES
        || mode === AmbientMode.HEARTS
        || mode === AmbientMode.SPARKLE
        || mode === AmbientMode.ALERT
        || mode === AmbientMode.MIC;
}

export function normalizeAmbientMode(value: unknown): AmbientMode {
    return typeof value === 'number' && ALL_AMBIENT_MODES.includes(value as AmbientMode)
        ? value as AmbientMode
        : AmbientMode.NONE;
}
